import { useState } from 'react';

interface useFakeQueryProps<T> {
  dataReturn: T;
  delay?: number;
}

type FakeLazyQueryTuple<T> = [
  () => Promise<void>,
  { data: T | null; loading: boolean },
];

const useFakeQuery = <TData>({
  dataReturn,
  delay = 1000,
}: useFakeQueryProps<TData>): FakeLazyQueryTuple<TData> => {
  const [data, setData] = useState<TData | null>(null);
  const [loading, setLoading] = useState(false);

  const query = async () => {
    setLoading(true);
    await new Promise(resolve => {
      setTimeout(() => {
        setData(dataReturn);
        setLoading(false);
        resolve(true);
      }, delay);
    });
  };

  return [
    query,
    {
      data,
      loading,
    },
  ];
};

export default useFakeQuery;
